<template>
  <div class="ViewAudit">
    <div class="father" v-if="GetResult.ApplyCity">
      <div class="sr">
        <div
          class="sr_title"
          :class="
            GetResult.ApplyStatus == 1
              ? 'sr_title1'
              : GetResult.ApplyStatus == 2
              ? 'sr_title2'
              : GetResult.ApplyStatus == 3
              ? 'sr_title3'
              : 'sr_title4'
          "
        >
          {{ examine[GetResult.ApplyStatus - 1] }}&nbsp;&nbsp;&nbsp;&nbsp;({{
            versionList[GetResult.ApplyVersion]
          }})
        </div>
        <div class="sr_body">
          <div class="company">
            <div class="cp_title">
              <span>公司信息</span>
            </div>
            <div class="cp_items flex_row">
              <div class="cp_item flex_row">
                <div class="item_info">公司名称</div>
                <div class="item_input flex_row">
                  <input
                    type="text"
                    :disabled="status"
                    v-model="GetResult.ApplyName"
                    required="required"
                    placeholder="请输入公司名称"
                  />
                </div>
              </div>
              <div class="cp_item flex_row">
                <div class="item_info">手机</div>
                <div class="item_input flex_row">
                  <input
                    class="text"
                    type="tel"
                    :disabled="status"
                    v-model="GetResult.ApplyTel"
                    maxlength="11"
                    placeholder="请输入手机号码"
                    @blur="checkPhone(GetResult.ApplyTel, 1)"
                  />
                </div>
              </div>
              <div class="cp_item flex_row">
                <div class="item_info">联系人</div>
                <div class="item_input flex_row">
                  <input
                    class="text"
                    type="text"
                    :disabled="status"
                    v-model="GetResult.ApplyPerson"
                    placeholder="请输入联系人"
                  />
                </div>
              </div>
            </div>
            <div class="cp_items flex_row">
              <div class="cp_item flex_row" style="position: relative">
                <div class="item_info">地区（省/市）</div>
                <div class="item_input flex_row">
                  <input
                    class="text"
                    type="text"
                    :disabled="status"
                    v-model="GetResult.ApplyRegion"
                    readonly="readonly"
                    placeholder="请输入地区（省/市）"
                    @click="
                      status ? '' : (GetResult.isShow = !GetResult.isShow)
                    "
                  />
                </div>
                <div
                  class="divwrap"
                  style="
                    left: 30%;
                    position: absolute;
                    top: 0.88rem;
                    font-size: 0.14rem;
                  "
                  v-show="GetResult.isShow"
                >
                  <div
                    class="mask"
                    style="
                      width: 100vw;
                      min-width: 1024px;
                      height: 100vh;
                      background: rgb(0, 0, 0, 0.3);
                      position: fixed;
                      left: 0;
                      top: 0;
                      z-index: -1;
                    "
                    @click="GetResult.isShow = false"
                  ></div>
                  <v-distpicker
                    type="mobile"
                    style="height: 6rem; background: #ffffff"
                    @selected="regionSelect($event, true)"
                    hide-area
                  >
                  </v-distpicker>
                </div>
              </div>

              <div class="cp_item flex_row">
                <div class="item_info">地址</div>
                <div class="item_input flex_row">
                  <input
                    class="text"
                    type="text"
                    :disabled="status"
                    v-model="GetResult.ApplyAddress"
                    placeholder="请输入地址"
                  />
                </div>
              </div>
              <div class="cp_item flex_row"></div>
            </div>
            <div class="cp_items flex_row">
              <div class="cp_item flex_row">
                <div class="item_info">营业执照</div>
                <div class="upfile_content flex_row" style="flex: 1">
                  <div class="fileBox flex_row">
                    <span
                      class="fileinput-button flex_row"
                      style="
                        width: 0.5rem;
                        height: 0.5rem;
                        background-size: 0.5rem auto;
                      "
                    >
                      <el-image
                        v-show="GetResult.business.FullURL"
                        style="width: 0.5rem; height: 0.5rem"
                        :src="GetResult.business.FullURL"
                        fit="cover"
                      >
                      </el-image>
                      <input
                        type="file"
                        :disabled="status"
                        style="width: 0.5rem; height: 0.5rem"
                        @change="getFileProcess($event, 'business')"
                      />
                    </span>
                  </div>
                  <div
                    class="fileBox-word"
                    style="
                      height: 0.1rem;
                      line-height: 0.1rem;
                      color: #b6b6b6;
                      font-size: 0.12rem;
                    "
                  >
                    （点击上传）
                  </div>
                </div>
              </div>
              <div class="cp_item flex_row">
                <div class="item_info">公司Logo</div>
                <div class="upfile_content flex_row">
                  <div class="fileBox flex_row">
                    <span
                      class="fileinput-button flex_row"
                      style="
                        width: 0.5rem;
                        height: 0.5rem;
                        background-size: 0.5rem auto;
                      "
                    >
                      <el-image
                        v-show="GetResult.logo.FullURL"
                        style="width: 0.5rem; height: 0.5rem"
                        :src="GetResult.logo.FullURL"
                        fit="cover"
                      >
                      </el-image>
                      <input
                        type="file"
                        :disabled="status"
                        style="width: 0.5rem; height: 0.5rem"
                        @change="getFileProcess($event, 'logo')"
                      />
                    </span>
                  </div>
                  <div
                    class="fileBox-word"
                    style="
                      height: 0.5rem;
                      line-height: 0.5rem;
                      color: #b6b6b6;
                      font-size: 0.12rem;
                    "
                  >
                    （点击上传）
                  </div>
                </div>
                <div
                  class="item_info"
                  style="flex: 1"
                  @click="modelShowDialog = true"
                >
                  模板
                </div>
                <!--                <div style="height: 0.5rem; flex: 1; display: flex; justify-content: flex-start" ><img style="height: 0.5rem" src="@/assets/img/logo_model.png" alt=""></div>-->
              </div>
              <div class="cp_item flex_row">
                <div class="item_info">电子签名：</div>
                <div
                  class="item_input flex_row"
                  @click="status ? '' : (dialogVisibleSign = true)"
                  style="flex: 1"
                >
                  <img
                    v-show="!GetResult.sign.FullURL"
                    style="width: 0.5rem"
                    src="@/assets/img/gw_add.png"
                    alt=""
                  />
                  <img
                    v-show="GetResult.sign.FullURL"
                    style="height: 0.5rem"
                    :src="GetResult.sign.FullURL"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="cp_items flex_row">
              <div class="cp_item flex_row">
                <div class="item_info">渠道编码：</div>
                <div class="item_input flex_row" style="flex: 1">
                  <!-- <el-select
                    size="small"
                    :disabled="status"
                    v-model="GetResult.ApplySource"
                    @change="changeApplySource"
                    placeholder="请选择渠道"
                  >
                    <el-option
                      v-for="item in ApplySourceList"
                      :key="item.Type"
                      :label="item.Label"
                      :value="item.Label"
                    >
                    </el-option>
                  </el-select> -->
                  <el-input
                    style="width: 200px"
                    size="small"
                    :disabled="status"
                    v-model="GetResult.ApplySource"
                    placeholder="请输入渠道编码"
                    @change="changeApplySource"
                  ></el-input>
                </div>
              </div>
              <div class="cp_item flex_row">
                <div class="item_info">版本：</div>
                <div class="item_input flex_row" style="flex: 1">
                  <el-select
                    size="small"
                    :disabled="status || !GetResult.ApplySource"
                    v-model="GetResult.ApplyVersion"
                    placeholder="请选择版本"
                  >
                    <el-option
                      v-for="item in ApplyVersionList"
                      :key="item.keys"
                      :label="item.value"
                      :disabled="item.disabled"
                      :value="item.keys"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="cp_item flex_row">
                <!-- <div class="item_info">期限：</div>
                <div class="item_input flex_row" style="flex: 1">
                  <el-select
                    :disabled="status"
                    v-model="GetResult.ApplyTerm"
                    placeholder="请选择期限"
                  >
                    <el-option
                      v-for="item in ApplyTermList"
                      :key="item.keys"
                      :label="item.Label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div> -->
              </div>
            </div>
          </div>
          <div class="store">
            <div class="store_top flex_row">
              <div class="se_title">
                <span>门店信息</span>
              </div>
              <button
                @click="dialogTableVisible = true"
                style="
                  background-color: #409eff;
                  border: none;
                  color: #fff;
                  padding: 0.09rem 0.13rem;
                  border-radius: 4px;
                  margin-right: 1%;
                "
              >
                查看账号
              </button>
            </div>
            <div class="store_content">
              <div class="content_top flex_row">
                <div>门店名称</div>
                <div>手机</div>
                <div>联系人</div>
                <div>地区（省/市）</div>
                <div>详细地址</div>
                <div>专家号码</div>
                <div>门头照片</div>
                <div :style="{ display: adoptShow ? 'block' : 'none' }">
                  账号
                </div>
                <div :style="{ display: adoptShow ? 'block' : 'none' }">
                  密码
                </div>
                <div :style="{ display: adoptShow ? 'block' : 'none' }">
                  修复码
                </div>
              </div>
              <div class="content_body">
                <div
                  class="store_items flex_row"
                  :style="{ background: index % 2 == 0 ? '#FFF' : '#DDD' }"
                  v-for="(item1, index) in GetResult.ListShop"
                  :key="item1.ApplyId"
                >
                  <div class="store_item flex_row">
                    <input
                      type="text"
                      :disabled="status"
                      v-model="item1.ApplyName"
                      placeholder="请输入店面名称"
                    />
                  </div>
                  <div class="store_item flex_row">
                    <input
                      type="tel"
                      v-model="item1.ApplyTel"
                      :disabled="status"
                      maxlength="11"
                      placeholder="请输入店面手机号码"
                      @blur="checkPhone(item1.ApplyTel, 2, index)"
                    />
                  </div>
                  <div class="store_item flex_row">
                    <input
                      type="text"
                      :disabled="status"
                      v-model="item1.ApplyPerson"
                      placeholder="请输入店联系人"
                    />
                  </div>
                  <div class="store_item flex_row" style="position: relative">
                    <input
                      type="text"
                      :disabled="status"
                      v-model="item1.ApplyRegion"
                      readonly="readonly"
                      placeholder="请输入店面省/市"
                      @click="showDivWrap(index)"
                    />
                    <div
                      class="divwrap"
                      v-show="item1.isShow"
                      style="
                        position: fixed;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        font-size: 0.25rem;
                      "
                    >
                      <div
                        class="mask"
                        style="
                          width: 100vw;
                          min-width: 1024px;
                          height: 100vh;
                          background: rgb(0, 0, 0, 0.3);
                          position: fixed;
                          left: 0;
                          top: 0;
                          z-index: -1;
                        "
                        @click="item1.isShow = false"
                      ></div>
                      <v-distpicker
                        type="mobile"
                        style="background: #ffffff; height: 40vh"
                        @selected="regionSelect($event, false, index)"
                        hide-area
                      >
                      </v-distpicker>
                    </div>
                  </div>
                  <div class="store_item flex_row">
                    <input
                      type="text"
                      :disabled="status"
                      v-model="item1.ApplyAddress"
                      placeholder="请输入店面地址"
                    />
                  </div>
                  <div class="store_item flex_row">
                    <input
                      type="tel"
                      v-model="item1.ApplyExpertTel"
                      :disabled="status"
                      maxlength="11"
                      placeholder="请输入专家手机号码"
                      @blur="checkPhone(item1.ApplyExpertTel, 3, index)"
                    />
                  </div>
                  <div class="store_item flex_row">
                    <div class="upfile_content flex_row">
                      <div class="fileBox flex_row">
                        <span
                          class="fileinput-button flex_row"
                          style="
                            width: 0.4rem;
                            height: 0.4rem;
                            background-size: 0.4rem auto;
                          "
                        >
                          <el-image
                            v-for="list in item1.ListUploadFile"
                            :key="list.FullURL"
                            v-show="list.FullURL"
                            style="width: 0.4rem; height: 0.4rem"
                            :src="list.FullURL"
                            fit="cover"
                          >
                          </el-image>
                          <input
                            type="file"
                            :disabled="status"
                            style="width: 0.4rem; height: 0.4rem"
                            @change="getFileProcess($event, '', index)"
                          />
                        </span>
                      </div>
                      <div
                        class="fileBox-word"
                        style="
                          height: 0.065rem;
                          line-height: 0.065rem;
                          color: #b6b6b6;
                          font-size: 0.11rem;
                        "
                      >
                        （点击上传）
                      </div>
                    </div>
                  </div>
                  <div
                    class="store_item flex_row"
                    :style="{ display: adoptShow ? 'block' : 'none' }"
                  >
                    <input
                      type="text"
                      :disabled="status"
                      v-model="item1.ApplyUserName"
                    />
                  </div>
                  <div
                    class="store_item flex_row"
                    :style="{ display: adoptShow ? 'block' : 'none' }"
                  >
                    <input type="text" :disabled="status" value="123" />
                  </div>
                  <div
                    class="store_item flex_row"
                    :style="{ display: adoptShow ? 'block' : 'none' }"
                  >
                    <input
                      type="text"
                      :disabled="status"
                      v-model="item1.ApplyCode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="reject" v-show="!status">
            <div class="rj_title">
              <span>驳回原因</span>
            </div>
            <div class="reject_content">
              {{ GetResult.ApplyReason }}
            </div>
          </div>
          <div class="my-10">
            <el-alert
              title="充值活动提示：累计充值满2万,赠送ERP进销存系统。"
              type="warning"
              show-icon
            >
            </el-alert>
          </div>
          <div class="adopt" v-show="adoptShow">
            <div class="adopt_item flex_row">
              <div class="title">
                ({{ versionList[GetResult.ApplyVersion] }})-安装说明
              </div>
              <div
                class="info"
                :style="{
                  display: GetResult.ApplyVersion == 0 ? 'block' : 'none',
                }"
              >
                <a href="http://2022.visumall.com/public/pdf.pdf">点击查看</a>
              </div>
              <div
                class="info"
                :style="{
                  display: GetResult.ApplyVersion == 1 ? 'block' : 'none',
                }"
              >
                <a href="http://2022.visumall.com/public/pdf1.pdf">点击查看</a>
              </div>
              <div
                class="info"
                :style="{
                  display: GetResult.ApplyVersion == 2 ? 'block' : 'none',
                }"
              >
                <a href="http://2022.visumall.com/public/pdf2.pdf">点击查看</a>
              </div>
              <div
                class="info"
                :style="{
                  display: GetResult.ApplyVersion == 3 ? 'block' : 'none',
                }"
              >
                <a href="http://2022.visumall.com/public/pdf3.pdf">点击查看</a>
              </div>
            </div>
            <div class="adopt_item flex_row">
              <div class="title">
                ({{ versionList[GetResult.ApplyVersion] }})-操作说明
              </div>
              <div
                class="info"
                :style="{
                  display: GetResult.ApplyVersion == 0 ? 'block' : 'none',
                }"
              >
                <a href="http://2022.visumall.com/public/pdf.pdf">点击查看</a>
              </div>
              <div
                class="info"
                :style="{
                  display: GetResult.ApplyVersion == 1 ? 'block' : 'none',
                }"
              >
                <a href="http://2022.visumall.com/public/pdf1.pdf"
                  >({{ versionList[GetResult.ApplyVersion] }})点击查看</a
                >
              </div>
              <div
                class="info"
                :style="{
                  display: GetResult.ApplyVersion == 2 ? 'block' : 'none',
                }"
              >
                <a href="http://2022.visumall.com/public/pdf2.pdf"
                  >({{ versionList[GetResult.ApplyVersion] }})点击查看</a
                >
              </div>
              <div
                class="info"
                :style="{
                  display: GetResult.ApplyVersion == 3 ? 'block' : 'none',
                }"
              >
                <a href="http://2022.visumall.com/public/pdf3.pdf"
                  >({{ versionList[GetResult.ApplyVersion] }})点击查看</a
                >
              </div>
            </div>
            <div class="adopt_item flex_row">
              <div class="title">
                ({{ versionList[GetResult.ApplyVersion] }})-PC端下载地址
              </div>
              <div class="info">
                <a
                  :style="{
                    display:
                      GetResult.ApplyVersion == 0 || GetResult.ApplyVersion == 1
                        ? 'block'
                        : 'none',
                  }"
                  href="http://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/PCVPDownload/VisumallSP.zip"
                  >点击下载</a
                >
                <a
                  :style="{
                    display:
                      GetResult.ApplyVersion == 2 || GetResult.ApplyVersion == 3
                        ? 'block'
                        : 'none',
                  }"
                  href="http://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/PCVPDownload/PCVPInstall.zip"
                  >点击下载</a
                >
              </div>
            </div>
            <div class="adopt_item flex_row">
              <div class="title">
                ({{ versionList[GetResult.ApplyVersion] }})-iPad端安装
              </div>
              <div class="info">
                <a
                  href="javascript:void(0);"
                  :style="{
                    display:
                      GetResult.ApplyVersion == 0 || GetResult.ApplyVersion == 1
                        ? 'block'
                        : 'none',
                  }"
                  >在APP Store里面搜索“视光无界”并下载安装APP</a
                >
                <a
                  href="javascript:void(0);"
                  :style="{
                    display:
                      GetResult.ApplyVersion == 2 || GetResult.ApplyVersion == 3
                        ? 'block'
                        : 'none',
                  }"
                  >在APP Store里面搜索“vision professor”并下载安装APP</a
                >
              </div>
            </div>

            <!-- 安卓端 -->
            <div class="adopt_item flex_row" style="align-items: start">
              <div class="title">
                ({{ versionList[GetResult.ApplyVersion] }})-安卓端安装
              </div>
              <div class="info">
                <img
                  width="100"
                  v-if="
                    GetResult.ApplyVersion == 0 || GetResult.ApplyVersion == 1
                  "
                  src="../../../assets/img/视光无界.png"
                  alt=""
                />
                <img
                  width="100"
                  v-else
                  src="../../../assets/img/视光中心.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="btn_row" v-show="!status">
            <el-button class="submit" @click="submit" v-show="true"
              >更新</el-button
            >
            <el-button class="submit" @click="cancel" v-show="false"
              >返回</el-button
            >
          </div>
        </div>
      </div>
      <el-dialog width="50%" :visible.sync="modelShowDialog">
        <div class="flex_row" style="height: calc(100vw * 0.5 * 0.45)">
          <img style="width: 90%" src="@/assets/img/logo_model.png" alt="" />
        </div>
      </el-dialog>
      <el-dialog
        title="电子签名"
        width="700px"
        :visible.sync="dialogVisibleSign"
      >
        <div class="SignDialog">
          <el-card class="qianming-container" body-style="padding:0px">
            <vue-esign
              ref="esign"
              :isCrop="isCrop"
              :width="600"
              :height="360"
              :lineWidth="lineWidth"
              :lineColor="lineColor"
              :bgColor.sync="bgColor"
            ></vue-esign>
            <div class="contro-container">
              <el-button type="danger" size="mini" @click="handleReset"
                >清空</el-button
              >
              <el-button type="primary" size="mini" @click="handleGenerate"
                >提交</el-button
              >
            </div>
          </el-card>
        </div>
      </el-dialog>
      <el-dialog
        class="accountDialog"
        title="账号"
        width="50%"
        :visible.sync="dialogTableVisible"
      >
        <div class="content_top flex_row">
          <div>管理端账号</div>
          <div>密码</div>
        </div>
        <div class="content_body1">
          <div class="store_items flex_row">
            <div class="store_item flex_row">
              <input
                style="width: 100%"
                type="text"
                :disabled="status"
                v-model="GetResult.ApplyAdminName"
              />
            </div>
            <div class="store_item flex_row">
              <input
                style="width: 100%"
                type="text"
                :disabled="status"
                value="123"
              />
            </div>
          </div>
        </div>
        <div class="content_top flex_row">
          <div>门店账号</div>
          <div>密码</div>
          <div>修复码</div>
        </div>
        <div class="content_body">
          <div
            class="store_items flex_row"
            :style="{ background: index % 2 == 0 ? '#FFF' : '#DDD' }"
            v-for="(item1, index) in GetResult.ListShop"
            :key="item1.ApplyId"
          >
            <div class="store_item flex_row">
              <input
                type="text"
                :disabled="status"
                v-model="item1.ApplyUserName"
              />
            </div>
            <div class="store_item flex_row">
              <input type="text" :disabled="status" value="123" />
            </div>
            <div class="store_item flex_row">
              <input type="text" :disabled="status" v-model="item1.ApplyCode" />
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import VDistpicker from "@/components/v-distpicker/Distpicker";
import bf from "@/publicFn/baseFn";
export default {
  name: "ViewAudit",
  components: {
    VDistpicker,
  },
  data() {
    return {
      mg: false,
      GetResult: {},
      Version_Channel_Id: '',
      examine: ["待审核", "审核通过", "审核失败", "审核不限"],
      versionList: ["眼镜店版", "视光中心版", "门诊版", "医院版"],
      modify: false,
      ApplyRegion: "",
      status: true, // false 审核失败 true 多种原因
      adoptShow: false,
      ApplySourceList: [
        {
          Type: 1,
          Label: "中视觉",
        },
        {
          Type: 2,
          Label: "视无界",
        },
        {
          Type: 3,
          Label: "佩极",
        },
        // {
        //   Type: 4,
        //   Label: "中天",
        // },
        {
          Type: 5,
          Label: "司徕柏",
        },
        // {
        //   Type: 6,
        //   Label: "爱维视",
        // },
        {
          Type: 7,
          Label: "海翔眼科",
        },
        {
          Type: 8,
          Label: "西安中康",
        },
        {
          Type: 9,
          Label: "易视",
        },
      ],
      ApplyVersionList: [],
      // ApplyVersionList: [
      //   { keys: 0, value: "眼镜店版", disabled: false },
      //   { keys: 1, value: "视光中心版", disabled: false },
      //   { keys: 2, value: "门诊版", disabled: false },
      //   { keys: 3, value: "医院版", disabled: false },
      // ],
      ApplyTermList: [
        { keys: 0, value: 3, Label: "三天" },
        { keys: 1, value: 365, Label: "一年" },
        { keys: 2, value: 730, Label: "二年" },
        { keys: 3, value: 1095, Label: "三年" },
        { keys: 4, value: 10950, Label: "三十年" },
      ],
      PriceList: [2800, 5800, 15000, 40000],

      dialogVisibleSign: false,
      lineWidth: 2,
      lineColor: "#000000",
      bgColor: "#ffffff",
      srcSign: "",
      isCrop: true,
      srcSignId: "",
      signStr: "",
      trueSrcSign: "",
      modelShowDialog: false,
      dialogTableVisible: false,
    };
  },
  created() {
    this.modelShowDialog = false;
    this.dialogVisibleSign = false;
    let ApplyTel = this.$store.state.bases.ApplyTel
      ? this.$store.state.bases.ApplyTel
      : "";
    let ApplyId = this.$store.state.bases.ApplyId
      ? this.$store.state.bases.ApplyId
      : "";
    if (ApplyTel !== "" || ApplyId !== "") {
      this._api.userCurdApi.ApplyGet(ApplyId, ApplyTel, false).then((res) => {
        if (res.msg == "Success") {
          let GetResult = res.GetResult;
          if (!res.GetResult) {
            this.$alert("经检测此手机号未注册，请在官网重新提交信息", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({
                  path: "/Register",
                  query: {
                    item: this.ApplyVersion,
                  },
                });
              },
            });
            return;
          }

          if (GetResult.ApplyStatus == 3) {
            this.status = false;
          } else if (GetResult.ApplyStatus == 2) {
            this.adoptShow = true;
          }
          GetResult.ApplyRegion = GetResult.ApplyProvince + GetResult.ApplyCity;
          GetResult.isShow = false;
          for (let i = 0; i < GetResult.ListShop.length; i++) {
            GetResult.ListShop[i].isShow = false;
            GetResult.ListShop[i].ApplyRegion =
              GetResult.ListShop[i].ApplyProvince +
              GetResult.ListShop[i].ApplyCity;
            if (!GetResult.ListShop[i].ListUploadFile) {
              GetResult.ListShop[i].ListUploadFile = [
                {
                  FullURL: "",
                },
              ];
            }
          }

          for (let i = 0; i < GetResult.ListUploadFile.length; i++) {
            if (GetResult.ListUploadFile[i].UFType == "CompanyLogo") {
              //公司Logo
              GetResult.logo = GetResult.ListUploadFile[i];
            } else if (GetResult.ListUploadFile[i].UFType == "CompanyLic") {
              //营业执照
              GetResult.business = GetResult.ListUploadFile[i];
            } else if (GetResult.ListUploadFile[i].UFType == "CompanySign") {
              //电子签名
              GetResult.sign = GetResult.ListUploadFile[i];
            }
          }
          if (!GetResult?.logo?.FullURL) {
            GetResult.logo = {
              FullURL: "",
            };
          }
          if (!GetResult?.business?.FullURL) {
            GetResult.business = {
              FullURL: "",
            };
          }
          if (!GetResult?.sign?.FullURL) {
            GetResult.sign = {
              FullURL: "",
            };
          }
          this.GetResult = GetResult;
          // this.GetResult.ApplySource = "c2d16f39-dab5-11ee-8e77-6c92bf62c4fc"; // 测试用
          this.GetResult.ApplySource = this.GetResult.ApplySource?.split("-")[0];
          this.changeApplySource(this.GetResult.ApplySource);
          this.GetResult.ApplyTerm = 10950;
        }
      });
    }
  },
  methods: {
    close() {
      this.mg = !this.mg;
    },
    checkData() {},
    async changeApplySource(val) {
      // this.ApplyVersionList = this.ApplyVersionList.map((item, index) => {
      //   let flag = true;
      //   if (
      //     ["海翔眼科"].includes(val) &&
      //     ["门诊版", "医院版"].includes(item.value)
      //   ) {
      //     flag = false;
      //   } else if (["中视觉", "佩极"].includes(val)) {
      //     flag = false;
      //   } else if (
      //     ["眼镜店版"].includes(item.value) &&
      //     !["海翔眼科"].includes(val)
      //   ) {
      //     flag = false;
      //   }
      //   if (
      //     ["西安中康"].includes(val) &&
      //     ["眼镜店版", "视光中心版", "门诊版"].includes(item.value)
      //   ) {
      //     flag = false;
      //   }
      //   return {
      //     ...item,
      //     disabled: flag,
      //   };
      // });
      // if (!["中视觉", "佩极", "海翔眼科"].includes(val)) {
      //   this.GetResult.ApplyVersion = 0;
      // } else if (["海翔眼科"].includes(val)) {
      //   this.GetResult.ApplyVersion = 2;
      // }
      try {
        const res = await this._api.userCurdApi.getVersionList({
          Channel_No: val,
        });
        // 过滤版本
        if (res.Result?.Channel_Versions) {
          this.Version_Channel_Id = res.Result?.Channel_Id;
          const list = [
            { keys: 0, value: "眼镜店版" },
            { keys: 1, value: "视光中心版" },
            { keys: 2, value: "门诊版" },
            { keys: 3, value: "医院版"},
          ];
          this.ApplyVersionList = list.filter((v) =>
            res.Result?.Channel_Versions.includes(v.keys)
          );
        } else {
          this.GetResult.ApplyVersion = null;
          this.ApplyVersionList = [];
        }
      } catch (error) {
        console.log("error");
      }
    },
    cancel() {
      this.$router.go(-1);
    },

    submit() {
      if (!this.GetResult.ApplyName) {
        this.$alert("公司名称为空", "提示");
        return;
      }
      if (!this.GetResult.ApplyTel) {
        this.$alert("公司手机号码为空", "提示");
        return;
      }
      if (!this.GetResult.ApplyPerson) {
        this.$alert("联系人为空", "提示");
        return;
      }
      if (!this.GetResult.ApplyRegion) {
        this.$alert("省/市为空", "提示");
        return;
        f;
      }
      if (!this.GetResult.ApplyAddress) {
        this.$alert("详细地址为空", "提示");
        return;
      }
      if (!this.GetResult.business.FullURL) {
        this.$alert("请提交营业执照", "提示");
        return;
      }
      if (!this.GetResult.logo.FullURL) {
        this.$alert("请提交公司Logo", "提示");
        return;
      }
      if (this.GetResult.ApplySource == "") {
        this.$alert("请提交渠道编码", "提示");
        return;
      }
      if (this.GetResult.ApplyTerm == "") {
        this.$alert("请选择期限", "提示");
        return;
      }
      if (this.ApplyTerm !== 3) {
        if (!this.GetResult.sign.FullURL) {
          this.$alert("当期限大于三天，必须提交电子签名", "提示");
          return;
        }
        // return;
      }
      if (this.GetResult.ListShop.length <= 0) {
        this.$alert("必须添加门店信息喔", "提示");
        return;
      }
      for (let i = 0; i < this.GetResult.ListShop.length; i++) {
        if (
          !this.GetResult.ListShop[i].ApplyName ||
          !this.GetResult.ListShop[i].ApplyTel ||
          !this.GetResult.ListShop[i].ApplyPerson ||
          !this.GetResult.ListShop[i].ApplyRegion ||
          !this.GetResult.ListShop[i].ApplyAddress ||
          !this.GetResult.ListShop[i].ApplyExpertTel ||
          !this.GetResult.ListShop[i].ListUploadFile ||
          !this.GetResult.ListShop[i].ListUploadFile[0].FullURL
        ) {
          this.$alert("门店信息有空", "提示");
          return;
        }
      }

      this.$alert("确认提交信息无误", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            let lo = this.$loading({
              text: "更新中...",
              background: "rgba(0, 0, 0, 0.8)",
            });
            this._api.userCurdApi
              .ApplyUpdate(
                this.GetResult.ApplyId,
                this.GetResult.ApplyName,
                this.GetResult.ApplyTel,
                this.GetResult.ApplyPerson,
                this.GetResult.ApplyProvinceId,
                this.GetResult.ApplyProvince,
                this.GetResult.ApplyCityId,
                this.GetResult.ApplyCity,
                this.GetResult.ApplyAddress,
                this.GetResult.ListShop,
                this.GetResult.ApplyVersion,
                this.Version_Channel_Id,
                this.GetResult.ApplyTerm
              )
              .then((res) => {
                lo.close();
                if (res.UpdateResult !== 0) {
                  this.$store.commit("bases/upApplyId", this.GetResult.ApplyId);
                  this.$store.commit(
                    "bases/upApplyTel",
                    this.GetResult.ApplyTel
                  );
                  this.$alert("更新成功", "提示", {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      this.$router.go(-1);
                    },
                  });
                } else {
                  this.$alert(res.msg, "提示");
                }
              });
          }
        },
      });
    },

    add() {
      this.GetResult.ListShop.push({});
    },

    regionSelect(res, type, index = 0) {
      let province = res.province.value.AreaName;
      let ApplyProvinceId = res.province.value.AreaId;
      let city = res.city.value.AreaName;
      let ApplyCityId = res.city.value.AreaId;
      if (type) {
        this.GetResult.ApplyRegion = province + "/" + city;
        this.GetResult.ApplyProvince = province;
        this.GetResult.ApplyProvinceId = ApplyProvinceId;
        this.GetResult.ApplyCity = city;
        this.GetResult.ApplyCityId = ApplyCityId;
        this.GetResult.isShow = false;
      } else {
        this.GetResult.ListShop[index].ApplyRegion = province + "/" + city;
        this.GetResult.ListShop[index].ApplyProvince = province;
        this.GetResult.ListShop[index].ApplyProvinceId = ApplyProvinceId;
        this.GetResult.ListShop[index].ApplyCity = city;
        this.GetResult.ListShop[index].ApplyCityId = ApplyCityId;
        this.GetResult.ListShop[index].isShow = false;
      }
    },

    getImageLimit(fileSize) {
      let limit = fileSize / 1024 / 1024;
      if (limit > 5) {
        return true;
      } else {
        return false;
      }
    },

    getFileProcess(e, type, index = 0) {
      //附件预览----合同及其他扫描件
      let _this = this;
      let files = e.target.files[0];
      let ufType = "CompanyLogo";
      const isIMAGE =
        files.type === "image/jpeg" ||
        files.type === "image/png" ||
        files.type === "image/gif";
      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式!");
        return false;
      }
      if (this.getImageLimit(files.size)) {
        let message = "";
        if (type == "business") {
          message = "图片过大，请重新提交营业执照";
        } else if (type == "logo") {
          message = "图片过大，请重新提交公司Logo";
        } else {
          message = "图片过大，请重新提交门头照片";
        }
        this.$alert(message, "提示");
        return;
      }
      let splitType = files.name.split(".");
      let srcType = "." + splitType[splitType.length - 1];
      if (!e || !window.FileReader) return; // 看支持不支持FileReader
      let reader = new FileReader();
      reader.readAsDataURL(files); // 这里是最关键的一步，转换就在这里
      let deleteId = "";
      reader.onloadend = function () {
        if (type == "business") {
          deleteId = _this.GetResult.business.UFId;
          _this.GetResult.business.FullURL = this.result;
          ufType = "CompanyLic";
        } else if (type == "logo") {
          deleteId = _this.GetResult.logo.UFId;
          _this.GetResult.logo.FullURL = this.result;
          ufType = "CompanyLogo";
        } else {
          deleteId = _this.GetResult.ListShop[index].ListUploadFile[0].UFId;
          _this.GetResult.ListShop[index].ListUploadFile[0].FullURL =
            this.result;
          _this.setData(index);
          ufType = "ShopPic";
        }

        let UFReId = "";
        if (type == "business" || type == "logo") {
          UFReId = _this.GetResult.ApplyId;
        } else {
          UFReId = _this.GetResult.ListShop[index].ApplyId;
        }

        if (deleteId) {
          _this._api.userCurdApi.UploadFileDeleteById(deleteId).then((res) => {
            //删除成功
            if (res.DeleteByIdReturn !== 0) {
              //加载图片
              _this.upLoadFile(
                type,
                this.result,
                UFReId,
                "Apply",
                srcType,
                ufType,
                "OSSPrivate",
                index
              );
            } else {
              console.log("删除失败");
            }
          });
        } else {
          _this.upLoadFile(
            type,
            this.result,
            UFReId,
            "Apply",
            srcType,
            ufType,
            "OSSPrivate",
            index
          );
        }
      };
    },

    upLoadFile(
      type,
      result,
      UFReId,
      Apply,
      srcType,
      ufType,
      OSSPrivate,
      index = 0
    ) {
      let _this = this;
      this._api.userCurdApi
        .UploadFileUpload(
          result.split(",")[1],
          UFReId,
          Apply,
          srcType,
          ufType,
          OSSPrivate
        )
        .then((res) => {
          if (res.msg == "Success") {
            if (type == "business") {
              _this.GetResult.business.UFId = res.Id;
            } else if (type == "logo") {
              _this.GetResult.logo.UFId = res.Id;
            } else if (type == "companySign") {
              _this.GetResult.sign.UFId = res.Id;
            } else {
              _this.GetResult.ListShop[index].ListUploadFile[0].UFId = res.Id;
            }
          }
        });
    },

    setData(index) {
      this.$set(this.GetResult.ListShop, index, {
        ApplyRegion: this.GetResult.ListShop[index].ApplyRegion,
        ApplyProvinceId: this.GetResult.ListShop[index].ApplyProvinceId,
        ApplyProvince: this.GetResult.ListShop[index].ApplyProvince,
        ApplyCityId: this.GetResult.ListShop[index].ApplyCityId,
        ApplyCity: this.GetResult.ListShop[index].ApplyCity,
        isShow: this.GetResult.ListShop[index].isShow,
        ApplyName: this.GetResult.ListShop[index].ApplyName,
        ApplyTel: this.GetResult.ListShop[index].ApplyTel,
        ApplyExpertTel: this.GetResult.ListShop[index].ApplyExpertTel,
        ApplyPerson: this.GetResult.ListShop[index].ApplyPerson,
        ApplyAddress: this.GetResult.ListShop[index].ApplyAddress,
        ApplyStatus: this.GetResult.ListShop[index].ApplyStatus,
        ApplyVersion: this.GetResult.ListShop[index].ApplyVersion,
        ApplyId: this.GetResult.ListShop[index].ApplyId,
        ListUploadFile: this.GetResult.ListShop[index].ListUploadFile,
      });
    },

    showDivWrap(index) {
      this.GetResult.ListShop[index].isShow =
        !this.GetResult.ListShop[index].isShow;
      this.setData(index);
    },

    checkPhone(iphone, type, index = 0) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(iphone)) {
        //alert("手机号码有误，请重填");
        this.$alert("手机号码有误，请重填", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (type == 1) {
              this.GetResult.ApplyTel = "";
            } else if (type == 2) {
              this.GetResult.ListShop[index].ApplyTel = "";
            } else if (type == 3) {
              this.GetResult.ListShop[index].ApplyExpertTel = "";
            }
          },
        });
      }
    },

    resSignUpLoadFile(type) {
      let UFReId = "";
      UFReId = this.GetResult.ApplyId;
      if (type == "delect") {
        if (!this.GetResult.sign.UFId) return;
        this._api.userCurdApi
          .UploadFileDeleteById(this.GetResult.sign.UFId)
          .then((res) => {
            //删除成功
            if (res.DeleteByIdReturn !== 0) {
              //加载图片
              this.GetResult.sign.UFId = "";
            } else {
              // _this.alert('删除失败','提示')
              console.log("删除失败");
            }
          });
      } else {
        if (this.GetResult.sign.UFId) {
          this._api.userCurdApi
            .UploadFileDeleteById(this.GetResult.sign.UFId)
            .then((res) => {
              //删除成功
              if (res.DeleteByIdReturn !== 0) {
                //加载图片
                // _this.upLoadFile(type, this.result, UFReId, 'Apply', srcType, ufType, 'OSSPrivate',index)

                this.upLoadFile(
                  "companySign",
                  this.GetResult.sign.FullURL,
                  UFReId,
                  "Apply",
                  ".png",
                  "CompanySign",
                  "OSSPrivate"
                );
              } else {
                console.log("删除失败");
              }
            });
        } else {
          this.upLoadFile(
            "companySign",
            this.GetResult.sign.FullURL,
            UFReId,
            "Apply",
            ".png",
            "CompanySign",
            "OSSPrivate"
          );
        }
      }
    },
    handleReset() {
      this.$refs.esign.reset();
      this.GetResult.sign.FullURL = "";
      this.resSignUpLoadFile("delect");
    },
    //生成签名图片..
    handleGenerate() {
      this.$refs.esign
        .generate()
        .then((res) => {
          this.GetResult.sign.FullURL = res;

          this.dialogVisibleSign = false;
          this.resSignUpLoadFile("upload");
          //resultImgId
        })
        .catch((err) => {
          this.$message.error("请签名之后提交！");
        });
    },
    //将base64转换为文件..
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
};
</script>

<style scoped lang="scss">
.ViewAudit {
  width: 100vw;
  min-width: 1024px;
  height: 100vh;
  position: relative;
  font-size: 14px;
  .back {
    width: 100%;
  }
  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #b6b6b6;
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #b6b6b6;
    // font-size: 1.8rem;
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #b6b6b6;
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #b6b6b6;
  }
  //点击上传的样式 start
  .upfile_content {
    //flex_row style="width: 60%"
    justify-content: flex-start;
    .fileBox {
      //flex_row
      justify-content: flex-start;
      .fileinput-button {
        //flex_row  style="width: 1.6rem; height: 1.6rem; background-size: 1.6rem auto;"
        float: left;
        position: relative;
        display: inline-block;
        overflow: hidden;
        background: url(../../../assets/img/gw_add.png) no-repeat;
        background-position: center center;

        input {
          position: absolute;
          left: 0px;
          top: 0px;
          opacity: 0;
          -ms-filter: "alpha(opacity=0)";
        }
      }
    }
    .fileBox-word {
      // style="height: 1.6rem; line-height: 1.6rem; color: #B6B6B6; font-size: 0.48rem;"
    }
  }
  //点击上传的样式 end
  .father {
    //position: absolute;
    background: url("../../../assets/img/informate.jpg");
    background-size: 100vw;
    width: 100%;
    min-width: 1024px;
    padding: 2% 2%;
    .sr {
      width: 96%;
      .sr_title {
        padding: 0.07rem 0.21rem;
        text-align: left;
        font-weight: 500;
        font-size: 16px;
        // font-size: 0.16rem;
        background: rgba(255, 255, 255, 0.83);
      } //审核状态，1-待审核，2-审核通过，3-审核失败，4-审核不限
      .sr_title1 {
        color: orange;
      }
      .sr_title2 {
        color: #27ba00;
      }
      .sr_title3 {
        color: red;
      }
      .sr_title4 {
        color: orange;
      }
      .sr_body {
        margin-top: 0.03rem;
        padding-bottom: 0.9rem;
        background: rgba(255, 255, 255, 0.83);
        .company,
        .store,
        .reject {
          padding-top: 0.17rem;
          .cp_title,
          .se_title,
          .rj_title {
            text-align: left;
            span {
              font-weight: bold;
              background: #97cbff;
              padding: 0.07rem 0.33rem;
              // font-size: 0.13rem;
              font-weight: 500;
              color: #000000;
            }
          }
          .cp_items {
            margin-top: 0.13rem;
            .cp_item {
              flex: 1;
              .item_info {
                margin-left: 0.33rem;
                text-align: left;
                width: 1.5rem;
                // font-size: 0.12rem;
                font-weight: bold;
                color: #808080;
              }
              .item_input {
                //width: 70%;
                flex: 1;
                justify-content: flex-start;
                input {
                  padding: 0.04rem 0;
                  border: none;
                  outline: none;
                  background: transparent;
                  // font-size: 0.12rem;
                  //font-weight: bold;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
              .item_content {
                justify-content: flex-start;
                .fileBox {
                  justify-content: flex-start;
                  .fileinput-button {
                    float: left;
                    position: relative;
                    display: inline-block;
                    overflow: hidden;
                    background: url(../../../assets/img/gw_add.png) no-repeat;
                    background-size: 1.6rem auto;
                    background-position: center center;

                    input {
                      position: absolute;
                      left: 0px;
                      top: 0px;
                      opacity: 0;
                      -ms-filter: "alpha(opacity=0)";
                    }
                  }
                }
                .fileBox-word {
                  height: 0.4rem;
                  line-height: 0.4rem;
                  color: #b6b6b6;
                  // font-size: 0.12rem;
                }
              }
            }
          }
        }
        .store {
          .store_top {
            justify-content: space-between;
            .inform {
              margin-right: 0.33rem;
              padding: 0.09rem 0.18rem;
              border: 0.01rem solid #fda100;
              border-radius: 0.11rem;
              // font-size: 0.13rem;
              font-weight: 500;
            }
          }
          .store_content {
            width: 98%;
            margin: 0.2rem auto 0;
            .content_top {
              background: #dddddd;
              div {
                padding: 0.12rem 0;
                flex: 1;
                // font-size: 0.11rem;
                font-weight: 500;
              }
            }
            .content_body {
              height: 0.75rem;
              overflow-y: auto;
              //overflow: hidden;
              .store_items {
                padding: 0.05rem 0;
                background: #fff;
                .store_item {
                  flex: 1;
                  input {
                    padding: 0.03rem 0;
                    text-align: center;
                    width: 100%;
                    border: none;
                    outline: none;
                    background: transparent;
                    // font-size: 0.11rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
              .back {
                background: #dddddd;
              }
            }
          }
        }
        .reject {
          padding-top: 0.085rem;
          .reject_content {
            text-indent: 2em;
            padding: 0.16rem;
            // font-size: 0.16rem;
            color: #808080;
            text-align: left;
          }
        }
        .adopt {
          .adopt_item {
            width: 98%;
            margin: 0.3rem auto 0;
            justify-content: flex-start;
            // font-size: 0.1rem;
            font-weight: bold;
            .title {
              color: #808080;
            }
            .info {
              margin-left: 0.29rem;
              a {
                text-decoration: none;
                color: #000000;
              }
            }
          }
        }
        .submit {
          margin: 0.23rem;
          padding: 0.1rem 0.34rem;
          background: #7cbcfd;
          box-shadow: 0px 0.04rem 0.04rem 0px rgba(11, 3, 6, 0.11);
          border-radius: 0.11rem;
          // font-size: 0.17rem;
          font-weight: bold;
          color: #ffffff;
        }
      }

      //修改地区选择框样式开始

      .divwrap {
        z-index: 999;
        overflow-y: auto;
        background: #fff;
        //overflow: hidden;
      }
      //修改地区选择框样式结束
    }
  }

  .SignDialog {
    //.show-img{
    //  width:400px;
    //  height:200px;
    //  border:1px solid #123456;
    //}
    //.show-info{
    //  width:400px;
    //  height:200px;
    //  font-size:24px;
    //  display:flex;
    //  align-items:center;
    //  justify-content:center;
    //}
    .qianming-container {
      width: 600px;
      height: 400px;
      margin: 20px auto;
      position: relative;
    }
    .contro-container {
      width: 600px;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      background-color: #d3d3d3;
      position: absolute;
      bottom: 0px;
    }
    .text {
      font-size: 14px;
    }
    .item {
      margin-bottom: 18px;
    }
    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }
    .clearfix:after {
      clear: both;
    }
    .box-card {
      width: 95%;
      margin-left: 2.5%;
      margin-top: 20px;
    }
  }

  .accountDialog {
    ::v-deep .el-dialog__body {
      padding: 5px 20px 20px;
    }
    .content_top {
      background: #dddddd;
      div {
        padding: 0.08rem 0;
        flex: 1;
        // font-size: 0.11rem;
        font-weight: 500;
      }
    }
    .content_body {
      height: 2rem;
      overflow-y: auto;
    }
    .content_body,
    .content_body1 {
      .store_items {
        padding: 0.05rem 0;
        background: #fff;
        .store_item {
          flex: 1;
          input {
            padding: 0.03rem 0;
            text-align: center;
            width: 100%;
            border: none;
            outline: none;
            background: transparent;
            // font-size: 0.11rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .back {
        background: #dddddd;
      }
    }
  }
}
</style>
